import { Box } from "@material-ui/core"
import { useIsDesktop } from "common/MediaQueries"
import styled from "styled-components"
import { StyledBody, StyledHeaderH2 } from "../wrappers/BodyText"

const StyledWrapper = styled(Box)`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${(p) => p.theme.breakpoints.up("md")} {
    align-items: center;
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    align-items: right;
    p {
      text-align: right;
    }
    h2 {
      text-align: center;
    }
    svg {
      width: 100%;
    }
  }
`

const StyledLine = styled.div`
  border: 0.5px solid ${(p) => p.theme.colors.darkGrey};
  margin-top: 40px;
  width: 100%;
`

const ModalHeader = ({ icon, title, subtitle }) => {
  const isDesktop = useIsDesktop()
  return (
    <StyledWrapper>
      {icon}
      <StyledHeaderH2 $margin={10}>{title}</StyledHeaderH2>
      <StyledBody style={{ width: isDesktop ? "400px" : "216px" }}>
        {subtitle}
      </StyledBody>
      {isDesktop && <StyledLine></StyledLine>}
    </StyledWrapper>
  )
}

export default ModalHeader
